
import {defineComponent, reactive, PropType, ref} from 'vue';
import { i18n } from '@tencent/vb-web-base';
import ClipboardJS from 'clipboard';
import { toast } from '@tencent/web-vbui/dist/components/t-toast/toast';
import SwiperCore, { Navigation, Pagination, A11y, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/swiper.less';
import 'swiper/components/pagination/pagination.less';
SwiperCore.use([Navigation, Pagination, A11y, Autoplay]);
interface ListItem {
  rowId: string;
  image: string;
  code?: string;
}

export default defineComponent({
  name: 'Slide',
  components:{
    Swiper,
    SwiperSlide,
  },
  props: {
    list: {
      type: Array as PropType<ListItem[]>,
      default: () => [],
    },
  },
  setup() {
    const swiperRef = ref<SwiperCore | null>(null);
    const { getT } = i18n;
    const $t = getT();
    const options = reactive({
      autoplay:{
        delay:5000,
        disableOnInteraction: false
      },
      loop:true,
      speed:500,
      pagination:{
        clickable: true
      },
      loopedSlides: 4,
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 15,
    });

    const handleClick = (item: ListItem) => {
      if (!item.code) {
        return;
      }
      const clipboard = new ClipboardJS('.swiper-slide');
      clipboard.on('success', () => {
        toast.show({
          title: $t('复制成功'),
        });
        clipboard.destroy();
      });
      clipboard.on('error', (err) => {
        console.log(err);
        toast.show({
          title: $t('复制失败'),
        });
        clipboard.destroy();
      });
    };
    return {swiperRef, options, handleClick};
  }
});
